import script from "./meeting-processing-loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./meeting-processing-loader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__